import { Flex, Text } from "@chakra-ui/react";
import TableList from "components/TableList";
import { Header } from "components/Header";
import { useEffect, useState } from "react";
import { api } from "services/api";
import utils from "utils";
import { toaster } from "components/ui/toaster";
import InputComp from "components/InputComp";
import PaginationComp from "components/PaginationComp";
import storage from "utils/storage";

const headers = [
  "Dealer",
  {
    label: "Refund",
    colW: "12ch",
    style: {
      textAlign: "end",
    },
  },
];

// const items = [
//   {
//     id: 1,
//     Daeler: "Bolton",
//     Refund: "Refund",
//   },
// ];

function Return() {
  const [isLoading, setIsLoading] = useState(false);
  const [list, setList] = useState([]);
  const [selectedItem, setSelectedItem] = useState();
  const [activePage, setActivePage] = useState(1);
  // const [searchTxt, setSearchTxt] = useState("");
  // const [searchLoading, setSearchLoading] = useState(false);

  const [dealers, setDealers] = useState();
  // const [dealerid, setDealerId] = useState();

  const [dateStart, setDateStart] = useState(
    storage.get("appcatch")?.return_datestart ||
      utils.dateToDateInput(
        new Date(new Date().setDate(new Date().getDate() - 7))
      )
  );

  const [dateEnd, setDateEnd] = useState(
    storage.get("appcatch")?.return_dateend || utils.dateToDateInput(new Date())
  );

  // const [branchname, setBranchname] = useState("");

  const onSelectItm = (data) => {
    setSelectedItem(data);
  };

  const getList = async (data) => {
    console.log("getList", data);
    // const stext = data?.searchTxt === undefined ? searchTxt : data.searchTxt;

    const pl = {
      datestart: data?.datestart || dateStart,
      dateend: data?.dateend || dateEnd,
      // date: data?.date || "",
      dealerid: data?.dealerid ?? utils.getDealerid(dealers),
      // searchTxt: stext,
      // limitId: data?.limitId || utils.getLimitId(filerLast),
      page: data?.page || activePage,
    };

    if (!pl.datestart || !pl.dateend || !pl.dealerid) {
      return;
    }
    setIsLoading(true);
    return api.getReturns(pl).then((res) => {
      setIsLoading(false);
      if (res?.status === 200) {
        if (data?.page) {
          setActivePage(data.page);
        }
        if (res?.data && res?.data[0]) {
          const l = res.data.map((item, index) => ({
            id: index,
            companyname: item.companyname,
            refundvalue: utils.formatAmountForTb(item?.refundvalue),
            data: item,
          }));
          setList(l);
        } else {
          setList([]);
        }
      } else {
        setList([]);
        toaster.create({
          title: res?.message,
          type: "error",
        });
      }
    });
  };

  const onDealersChange = (data) => {
    console.log("onDealersChange", data);
    setDealers(data?.list ? [...data.list] : []);
    // setBranchname(data?.item?.label || "");

    // if (data?.action !== "useState") {
      getList({
        dealerid: data?.item?.data?.dealerid,
        action: data?.action,
        page: 1,
      });
    // }

    // if (data?.action === "useState") {
    //   if (data?.item?.data?.dealerid || data?.item?.data?.dealerid === 0) {
    //     getList({
    //       dealerid: data?.item?.data?.dealerid,
    //       action: data?.action,
    //     });
    //   }
    // } else {
    //   getList();
    // }

    const appcatch = storage.get("appcatch") || {};
    appcatch.return_dealerid = data?.item?.data?.dealerid;
    storage.set("appcatch", appcatch);
  };

  // const getDealers = async ({ action }) => {
  //   setIsLoading(true);
  //   api.getDealers().then((res) => {
  //     console.log("getDealers =", res);
  //     setIsLoading(false);
  //     if (res?.status === 200) {
  //       if (res?.data && res?.data[0]) {
  //         const arr = res.data.map((a, index) => ({
  //           key: `dealer-${index}`,
  //           value: `${a.companyname}-${index}`,
  //           label: a.companyname,
  //           data: { dealerid: a.dealerid },
  //         }));

  //         // if (action !== "useState") {
  //         // arr[0].selected = true;
  //         // setBranchname(arr[0].label);
  //         // getPolicyTypes({ dealerid: arr[0].data.dealerid });
  //         // }

  //         // if (action === "useState" && itemData?.branchid) {
  //         //   let indx;
  //         //   let item;
  //         //   let arr2 = arr?.map((a, index) => {
  //         //     if (a.data.dealerid === itemData.branchid) {
  //         //       a.selected = true;
  //         //       indx = index;
  //         //       item = a;
  //         //     } else {
  //         //       a.selected = false;
  //         //     }
  //         //     return a;
  //         //   });

  //         //   onDealersChange({
  //         //     index: indx,
  //         //     item: item,
  //         //     list: arr2,
  //         //     action: action,
  //         //   });
  //         //   // setBranchname(arr[0].label);
  //         //   // getPolicyTypes({ dealerid: itemData.dealerid, action });
  //         // } else {
  //         onDealersChange({
  //           // index: indx,
  //           // item: item,
  //           list: arr,
  //           action: action,
  //         });
  //         // setDealers(arr);
  //         // }
  //       }
  //     } else {
  //       onDealersChange({
  //         action: action,
  //       });
  //       toaster.create({
  //         title: res?.message,
  //         type: "error",
  //       });
  //     }
  //   });
  // };

  const onChangeDate = (v, action) => {
    const appcatch = storage.get("appcatch") || {};

    if (action === "date-start") {
      setDateStart(v);
      if (v && dateEnd) {
        getList({
          datestart: v,
          dateend: dateEnd,
        });
      }
      appcatch.return_datestart = v;
    } else if (action === "date-end") {
      setDateEnd(v);
      if (dateStart && v) {
        getList({
          datestart: dateStart,
          dateend: v,
        });
      }
      appcatch.return_dateend = v;
    }
    storage.set("appcatch", appcatch);
  };

  const onChangePage = (data) => {
    if (data?.page === activePage) {
      return;
    }
    getList({
      page: data.page,
      // limitId: utils.getLimitId(filerLast),
      // searchTxt: searchTxt,
      // dealerid: utils.getDealerid(dealers),
    });
  };

  useEffect(() => {
    const cd = async () => {
      const appcatch = storage.get("appcatch") || {};

      if (!appcatch?.return_dealerid) {
        await getList({ action: "useState" });
      }

      // await getDealers({ action: "useState" });
      await utils.getDealers({
        setIsLoading,
        action: "useState",
        onDealersChange,
        allOption: false,
        defaultVal: appcatch?.return_dealerid,
      });
    };

    cd();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Flex flex={1} overflow={"hidden"} direction={"column"} p={"2rem"}>
      <Header label={"Return"} isLoading={isLoading} />

      <Flex
        width={"100%"}
        flexFlow={"wrap"}
        gap={"1rem"}
        alignItems={"center"}
        mb={"1rem"}
      >
        {/* <Flex flexFlow={"wrap"} alignItems={'center'} gap={'2rem'}> */}
        <InputComp
          value={dateStart}
          onChange={(v) => onChangeDate(v, "date-start")}
          type="date"
        />
        <Text>To &nbsp;</Text>
        <InputComp
          value={dateEnd}
          onChange={(v) => onChangeDate(v, "date-end")}
          type="date"
        />
        <InputComp
          type={"dropdown"}
          items={dealers}
          onChange={onDealersChange}
        />
        {/* <Field.Label textStyle={fs}>Town</Field.Label> */}
        {/* <Input type="date" w={"10rem"} textStyle={fs} /> */}
        {/* <DropDown items={dealers} onChange={onDealersChange} /> */}
      </Flex>
      {/* <Flex justifyContent="space-between" gap={"3"}> */}
      {/* <Button variant="outline" onClick={onNew}>New</Button> */}
      {/* </Flex> */}
      <TableList
        type={"simple"}
        headers={headers}
        items={list}
        onSelect={onSelectItm}
        selectedItem={selectedItem}
      />
      <PaginationComp
        // pageSize={10}
        itemsLength={list?.length}
        activePage={activePage}
        onChange={onChangePage}
      />
    </Flex>
  );
}

export default Return;
